import { OrderService } from '@/services/order.service'
import { StatService } from '@/services/stat.service'
import { showErrorToast } from './helpers'

export const orderActions = {
  async loadOrders({ commit }, page) {
    try {
      const response = await OrderService.orders(page)
      commit('SET_ORDERS', response.data)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadOrder({ commit }, id) {
    try {
      const response = await OrderService.getOrder(id)
      commit('SET_ORDER', response.data.data)
    } catch (err) {
      showErrorToast(err)
      console.error(err)
    }
  },

  async loadOrderItemStats({ commit }) {
    const response = await StatService.getIsNewOrderItems()
    commit('SET_ORDER_STATS', response.data)
  }
}
